"use strict";

exports.__esModule = true;
exports.defaultContextObject = exports.EditorContextProvider = exports.EditorContext = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultContextObject = {
  selectedTheme: {},
  metadata: {
    address1: ""
  },
  plugins: {},
  editorState: ""
};
exports.defaultContextObject = defaultContextObject;

var EditorContext = _react["default"].createContext(defaultContextObject);

exports.EditorContext = EditorContext;

var getPlugins = function getPlugins(plugins) {
  return plugins.reduce(function (res, value) {
    res[value.type] = {
      showEditor: false,
      data: value.data || {},
      editorComponent: value.editorComponent,
      actions: value.actions,
      metadata: value.metadata
    };
    return res;
  }, {});
};

var EditorContextProvider = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(EditorContextProvider, _React$Component);

  function EditorContextProvider() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", _extends({}, defaultContextObject, _this.props.initialState, {
      plugins: getPlugins(_this.props.plugins || [])
    }));

    _defineProperty(_assertThisInitialized(_this), "onUpdateMetadata", function (newMetadata) {
      _this.setState(function (state) {
        return {
          metadata: _extends({}, state.metadata, newMetadata)
        };
      }, function () {
        if (_this.props.onUpdateMetadata) {
          _this.props.onUpdateMetadata(_this.state.metadata);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "registerPlugin", function (name, data) {
      _this.setState(function (state) {
        var _extends2;

        return {
          plugins: _extends({}, state.plugins, (_extends2 = {}, _extends2[name] = {
            data: data,
            showEditor: false
          }, _extends2))
        };
      } //  () => { console.debug("Updated:", this.state) }
      );
    });

    _defineProperty(_assertThisInitialized(_this), "showPluginEditor", function (name, status, data) {
      if (data === void 0) {
        data = {};
      }

      _this.setState(function (state) {
        var plugins = state.plugins;
        plugins[name].showEditor = status;
        plugins[name].data = data; //console.debug("PLUGINS:", plugins, status);

        return {
          plugins: plugins
        };
      } // () => {
      //      console.debug("Updated plugin editor:", this.state.plugins[name], status) }
      );
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeEditorState", function (newEditorState) {
      _this.setState({
        editorState: newEditorState
      }, function () {
        _this.props.onChangeEditorState(_this.state.editorState);
      });
    });

    return _this;
  }

  var _proto = EditorContextProvider.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.reload) this.props.reload(this.reload.bind(this));
  };

  _proto.reload = function reload() {
    this.setState(_extends({}, defaultContextObject, this.props.initialState, {
      plugins: getPlugins(this.props.plugins || [])
    }));
  };

  _proto.render = function render() {
    // console.debug("Ediotr context:",this.state)
    return /*#__PURE__*/_react["default"].createElement(EditorContext.Provider, {
      value: _extends({}, this.state, {
        onUpdateMetadata: this.onUpdateMetadata,
        registerPlugin: this.registerPlugin,
        showPluginEditor: this.showPluginEditor,
        onChangeEditorState: this.onChangeEditorState
      })
    }, this.props.children);
  };

  return EditorContextProvider;
}(_react["default"].Component);

exports.EditorContextProvider = EditorContextProvider;